import React from 'react';
import { Box, Divider } from '@material-ui/core';
import BaseAssessmentHeader from './BaseAssessmentHeader';

type Props = {
  TopComponent: React.ReactElement;
  BottomComponent?: React.ReactElement;
  OutsideHeader?: React.ReactElement;
  showModuleHeader?: boolean;
  showDivider?: boolean;
  showBottomDivider?: boolean;
  headerList: any[];
  title: string;
};
const AllModuleAssessmentAcceleratorLayout: React.FC<Props> = ({
  TopComponent,
  BottomComponent,
  OutsideHeader,
  showModuleHeader,
  showDivider,
  headerList,
  showBottomDivider = true,
  title = ''
}) => {
  return (
    <Box display="flex" flex={1} flexDirection="column" marginTop={3}>
      {OutsideHeader || (
        <BaseAssessmentHeader
          showHeader={showModuleHeader}
          showDivider={showDivider}
          allModuleHeaderList={headerList}
          title={title}
        />
      )}
      {TopComponent}
      {BottomComponent && (
        <>
          {showBottomDivider && <Divider />}
          {BottomComponent}
        </>
      )}
    </Box>
  );
};

export default AllModuleAssessmentAcceleratorLayout;
